import { Component } from "solid-js";

interface FootwearIconProps {
  class?: string;
}

export const FootwearIcon: Component<FootwearIconProps> = (props) => {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <path
        d="M13.2135 9.79069H16L18.1716 8.46747C18.5185 8.25614 18.9428 8.21441 19.3242 8.3541C19.7057 8.4938 20.0027 8.7997 20.131 9.1851L23.203 18.4009L27.5248 24.1633C28.0705 24.8909 28.1582 25.8643 27.7515 26.6777C27.3448 27.4911 26.5134 28.0049 25.604 28.0049H20.3618C18.8794 28.0059 17.4637 27.3891 16.4548 26.3029L5.0621 14.0405C4.32223 13.2425 3.93925 12.1776 4.00141 11.0911C4.06357 10.0047 4.56551 8.99045 5.39157 8.28206L9.95747 4.36976C10.4159 3.97708 11.0609 3.8871 11.6093 4.13936C12.1577 4.39162 12.5091 4.93997 12.5092 5.54359V9.79069H16"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.99512 23.3363H6.66289"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.6646 28.005H3.99512"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M27.4007 24.0033H20.6992C19.5888 24.0063 18.5277 23.5449 17.7727 22.7307L4.86865 8.83429"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.334 17.3339L22.5428 16.4322"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16 13.9991L21.4209 13.0614"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
